/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getActorLikes'

export { $nsid }

/** Get a list of posts liked by an actor. Requires auth, actor must be the requesting account. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    feed: l.array(
      l.ref<FeedDefs.FeedViewPost>((() => FeedDefs.feedViewPost) as any),
    ),
  }),
  ['BlockedActor', 'BlockedByActor'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
